import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzInputNumberWebComponent, InputWidthValues } from '../../../../../../ui/gzInput';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';
import { WEB_COMPONENT_GZ_INPUT_NUMBER_WITH_DROPDOWN } from '../../../../../../webcomponents.constants';
import { FormFieldInput } from '../../../../../../ui/gzForm/formField/component/FormFieldInput';
import { GzInputNumberWithDropdownFieldProps } from '../types/types';
import { ExchangeScanTaskTimeUnit } from '../../gzExchangeScanTask/types';
import { GzDropdownWebComponent } from '../../../../../../ui/gzDropdown';

/**
 * @summary Input number with dropdown list component for the Exchange Scan Task form contents
 * @tag gz-input-number-with-dropdown
 */
@customElement(WEB_COMPONENT_GZ_INPUT_NUMBER_WITH_DROPDOWN)
export class GzInputNumberWithDropdownWebComponent extends FormFieldInput<GzInputNumberWithDropdownFieldProps> {
  @property({ type: Number, attribute: true, reflect: true })
  public inputMinValue: number;

  @property({ type: Number, attribute: true, reflect: true })
  public inputDefaultValue: number;

  @property({ type: String, attribute: true, reflect: true })
  public inputWidth: InputWidthValues;

  @property({ type: Array, attribute: true, reflect: true })
  public dropdownOptions: Array<SelectOption>;

  @property({ type: Number, attribute: true, reflect: true })
  public dropdownDefaultValue: number | string;

  @property({ type: Boolean, reflect: true, attribute: true })
  public disabled = true;

  @query('gz-input-number')
  private inputNumber: GzInputNumberWebComponent;
  @query('gz-dropdown')
  private dropdown: GzDropdownWebComponent;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-input-number
        .min="${this.inputMinValue ?? 1}"
        .value="${this.inputDefaultValue ?? 1}"
        .inputWidth="${this.inputWidth ?? InputWidthValues.SMALL}"
        .disabled="${this.disabled}"
      ></gz-input-number>
      <gz-dropdown
        options="${JSON.stringify(this.dropdownOptions)}"
        .value="${this.dropdownDefaultValue}"
        .disabled="${this.disabled}"
      >
      </gz-dropdown>
    `;
  }

  public getFormValue(): GzInputNumberWithDropdownFieldProps {
    return {
      inputValue: this.inputNumber.value ?? 1,
      selectedTimeUnit: this.dropdown.value as ExchangeScanTaskTimeUnit,
    };
  }

  public setFormValue(value: GzInputNumberWithDropdownFieldProps): void {}
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-input-number-with-dropdown': GzInputNumberWithDropdownWebComponent;
  }
}
